document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("modal-ingredients");
  const trigger = document.querySelector(".global-ingredients");
  const closeBtn = document.querySelector(".modal-content .close");
  const generalAccordions = document.querySelectorAll(
    ".twat-accordion-item:not(.faqs-accordion)"
  );
  const rightAssets = document.querySelectorAll(".column-right .asset");

  trigger?.addEventListener("click", () => {
    modal.style.display = "block";
  });

  closeBtn?.addEventListener("click", () => {
    modal.style.display = "none";
  });

  window.addEventListener("click", (event) => {
    if (event.target === modal) {
      modal.style.display = "none";
    }
  });

  if (generalAccordions.length > 0 && rightAssets.length > 0) {
    generalAccordions[0].classList.add("is-open");
    rightAssets[0].classList.add("is-open");
    generalAccordions[0].setAttribute("open", "true");
  }

  generalAccordions.forEach((accordion, index) => {
    const summary = accordion.querySelector(".twat-accordion-item__title");

    summary?.addEventListener("click", (event) => {
      event.preventDefault();

      const isOpen = accordion.classList.contains("is-open");

      generalAccordions.forEach((a) => {
        a.classList.remove("is-open");
        a.removeAttribute("open");
      });

      rightAssets.forEach((asset) => asset.classList.remove("is-open"));

      if (!isOpen) {
        accordion.setAttribute("open", "true");
        accordion.classList.add("is-open");
        rightAssets[index]?.classList.add("is-open");
        
        if (window.innerWidth <= 768) {
          const { top, bottom } = accordion.getBoundingClientRect();
          const isInView = top >= 0 && bottom <= window.innerHeight || top > 400;
          const offsetPosition = top + window.scrollY - 250;
        
          if (!isInView) {
            window.scrollTo({ top: offsetPosition, behavior: "smooth" });
          }
        }
      }
    });
  });
});
